import client from '.'
import { getAuthHeaders } from 'utils/requests'
import { cachedFetch } from 'utils/memoryCache'
import { CACHE_TTL } from 'utils/cacheTtl'

const PREFIX = 'schedule:'

const listSchedule = async (filters = {}) => {
  const config = {
    headers: getAuthHeaders(),
    params: filters,
  }

  if (Object.keys(filters).length > 0) {
    return client.get('/list', config)
  }

  return await cachedFetch(
    `${PREFIX}list`,
    async () => client.get('/list', config),
    { ttlMs: CACHE_TTL.SCHEDULE }
  )
}

export default listSchedule
